import { createApp } from 'vue'
import store from 'store'

import ProductTile from './ProductTile.vue'

const el = '.nti-component--product-tile'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(ProductTile)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}